/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { ThemeOptions, createTheme, alpha } from "@mui/material/styles";

const hondaColorScheme = {
  attentionGreen: {
    main: "#00c500",
    dark: "#008700",
    light: "#d9f7d9",
    contrastText: "#fff",
  },
  attentionAmber: {
    main: "#ff6600",
    dark: "#8c3400",
    light: "#ffe8d9",
    contrastText: "#fff",
  },
  attentionRed: {
    main: "#f00000",
    dark: "#8c0000",
    light: "#fdd9d9",
    contrastText: "#fff",
  },
  text: {
    black: "#35343A",
    grey: "#8E8D95",
  },
};

const themeOption: ThemeOptions = {
  palette: {
    primary: {
      main: "#00b2ff",
    },
    secondary: {
      main: "#333",
    },
    success: hondaColorScheme.attentionGreen,
    warning: hondaColorScheme.attentionAmber,
    error: hondaColorScheme.attentionRed,
    text: {
      primary: alpha(hondaColorScheme.text.black, 0.87),
      secondary: alpha(hondaColorScheme.text.black, 0.6),
      disabled: alpha(hondaColorScheme.text.black, 0.38),
    },
  },

  typography: {
    button: {
      textTransform: "none",
    },
  },

  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#fff",
        },
      },
    },
    MuiDialog: {
      defaultProps: {
        PaperProps: {
          sx: {
            border: 1,
            borderRadius: 5,
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        spacing: {
          justifyContent: "space-evenly",
          padding: 12.5,
        },
        root: {
          backgroundColor: "#e0e0e0",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          backgroundColor: "#fff",
        },
        root: {
          "@media (hover: none)": {
            ":hover": {
              backgroundColor: "#fff",
            },
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          "@media (hover: none)": {
            ":hover": {
              backgroundColor: "transparent",
            },
          },
        },
      },
    },
  },
};

// A custom theme for this app
export const theme = createTheme(themeOption);
